import Ajax from '../../../../common/js/Ajax.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import TippspielWidget from '../TippspielWidget.js';

export default class LogoutWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}
	
	onLoginReady() {
		Ajax.rpc('/logout', () => {
			MessageUtils.ok(this.$widget, 'Du wurdest erfolgreich ausgeloggt.\n[Erneut einloggen|/login]');
		}, error => {
			MessageUtils.error(this.$widget, 'Ausloggen fehlgeschlagen', error);
		});
	}

	static updateNavigation() {
		Ajax.rpc('/isLoggedIn', loggedIn => {
			$('.js_logout-nav').toggleClass('hidden', !loggedIn);
		});
	}

}
